import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { PickSlotCard, ProspectCard } from "../DraftOdds/DraftOddsComponents";
import "../DraftOdds/draftOddsBoard.css";

function HomeDraftOddsBoard({ loading, payload, draftYear, compact = false }) {
    const picks = compact ? (payload?.picks || []).slice(0, 5) : (payload?.picks || []);
    const prospects = compact ? (payload?.prospects || []).slice(0, 6) : (payload?.prospects || []);
    const hasPicks = picks.some((slot) => slot.candidates?.length > 0);
    const hasProspects = prospects.length > 0;

    if (loading) {
        return (
            <section className="draft-odds-section">
                <div className="draft-odds-loading">
                    <CircularProgress size={28} sx={{ color: "var(--brand-strong)" }} />
                </div>
            </section>
        );
    }

    if (!hasPicks && !hasProspects) {
        return null;
    }

    return (
        <section className={`draft-odds-section${compact ? " draft-odds-section--compact" : ""}`}>
            <div className="draft-odds-header">
                <div>
                    <Typography variant="h4" component="h2" className="draft-odds-title">
                        Draft Odds Board
                    </Typography>
                    {!compact && (
                        <Typography variant="body2" component="p" className="draft-odds-subtitle">
                            Simulated pick probabilities for the {draftYear} NHL Draft — who goes where, and how the top prospects could land.
                        </Typography>
                    )}
                    {compact && (
                        <Typography variant="body2" component="p" className="draft-odds-subtitle">
                            Simulated {draftYear} pick probabilities — tap a prospect for the full chart.
                        </Typography>
                    )}
                </div>
            </div>

            {hasPicks && (
                <div className="draft-odds-picks-panel">
                    <Typography variant="overline" className="draft-odds-panel-label">
                        Likely names by pick
                    </Typography>
                    <div className="draft-odds-picks-scroll">
                        {picks.map((slot) => (
                            <PickSlotCard key={slot.pick} slot={slot} />
                        ))}
                    </div>
                </div>
            )}

            {hasProspects && (
                <div className="draft-odds-prospects-panel">
                    <Typography variant="overline" className="draft-odds-panel-label">
                        Top prospect landing spots
                    </Typography>
                    <div className="draft-odds-prospects-grid">
                        {prospects.map((prospect) => (
                            <ProspectCard key={prospect.player_id} prospect={prospect} />
                        ))}
                    </div>
                </div>
            )}

            {hasProspects && (
                <div className="draft-odds-footer">
                    <Link to="/draft-odds" className="view-more-link">
                        <Typography variant="body1">
                            Explore full draft odds
                            <ArrowForwardIosIcon />
                        </Typography>
                    </Link>
                </div>
            )}
        </section>
    );
}

export default HomeDraftOddsBoard;
